export default __webpack_public_path__ + "static/button-evolution-bba005c2edf762bb6d21926958024996dbeb4198764eea85647e738b374fd7bd.png";